
import '../scss/style.scss';
require("fslightbox");
import { menuMobile } from './menu_mobile';
import { category_mobile } from './woocommerce'
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
//import SplitType from 'split-type';
gsap.registerPlugin(ScrollTrigger);


menuMobile();
category_mobile();

/** LENIS INIZIALIZZAZIONE */
const lenis = new Lenis();

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

/** Split type */

// Inizializza SplitType sui titoli
/*
const titoli = document.querySelectorAll('.titolo');
titoli.forEach(titolo => {
  const testo = new SplitType(titolo, { types: 'chars' });

  gsap.from(testo.chars, {
    scrollTrigger: {
      trigger: titolo, // Ogni titolo avrà il proprio trigger
      start: 'top 80%',
      //markers: true
    },
    opacity: 0,
    y: 15,
    stagger: 0.05,
    duration: 0.7,
    ease: 'power2.out',
    delay: 0.3
  });
}); */



/** animation gsap **/
gsap.set(".anim-y", {y:40, opacity: 0});
ScrollTrigger.batch(".anim-y", {
    start: 'top 90%',
    onEnter: batch => gsap.to(batch, {opacity:1, y:0, stagger:0.17}),
    scrub:true
});

gsap.set(".zoom-out", {scale:1, duration: 0.2});
ScrollTrigger.batch(".zoom-out", {
  start: 'top 90%',
  onEnter: batch => gsap.to(batch, {scale:0.85, stagger:0.17}),
  scrub:true
});

// timeline cooperativa sociale

const tlEventi = gsap.timeline({
  scrollTrigger: {
    trigger: ".coop-sociale-home",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  }
}); 

tlEventi.to(".bg-coop-home", {
  y: "-15%",
  ease: "none",
});

tlEventi.to(".overlay", {
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  ease: "none",
}, "<");

// animazione eventi

gsap.to(".bg-eventi-home", {
  scale: 1.2,
  scrollTrigger: {
    trigger: ".eventi-home",
    start: "top bottom",
    end: "bottom top",
    scrub: 4
  }
})

/* animazione banner cooperativa 

gsap.to("#banner-cooperativa", {
  clipPath: "inset(0% 0%)", // Mostra l'immagine completamente
  scrollTrigger: {
    trigger: "#banner-cooperativa",
    start: "top 80%", // Inizia quando la sezione è visibile all'80% dall'alto
    end: "top 20%",   // Termina quando la sezione raggiunge il 20% dall'alto
    scrub: true       // Sincronizza l'animazione con lo scroll
  }
});

*/

gsap.to("#banner-cooperativa img", {
  y: "-20%",  // Modifica il valore per regolare l'intensità del parallax
  ease: "none",
  scrollTrigger: {
    trigger: "#banner-cooperativa",
    start: "top bottom",    // Inizia l'animazione quando la sezione entra in vista
    end: "bottom top",      // Termina quando la sezione esce dalla vista
    scrub: 2             // Sincronizza l'animazione con lo scroll
  }
});